import { useCallback, useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { imageUrlToBlob } from "../../utils/application-helper";

const ImagePreview = ({
  imageSrc,
  cropImageHandler,
  cropEnabled,
  fileType = "image",
}) => {
  const [imageUrl, setImageUrl] = useState(imageSrc);
  const cropperRef = useRef(null);

  useEffect(() => {
    const fetchImage = async () => {
      if (cropEnabled && imageSrc.startsWith("https")) {
        try {
          const blob = await imageUrlToBlob(imageSrc);
          if (blob) {
            const blobUrl = URL.createObjectURL(blob);
            setImageUrl(blobUrl);
          } else {
            console.error("Failed to fetch image.");
          }
        } catch (error) {
          console.error("Error fetching image:", error);
        }
      } else {
        setImageUrl(imageSrc);
      }
    };

    fetchImage();
  }, [cropEnabled, imageSrc]);

  const onCrop = useCallback(() => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const canvas = cropper.getCroppedCanvas();
      if (canvas) {
        cropImageHandler(canvas.toDataURL());
      }
    }
  }, [cropImageHandler]);

  return (
    <>
      {cropEnabled ? (
        <Cropper
          src={imageUrl}
          style={{ width: "100%", height: "300px" }}
          initialAspectRatio={16 / 9}
          guides={true}
          crop={onCrop}
          ref={cropperRef}
          checkCrossOrigin={false}
        />
      ) : fileType === "image" ? (
        <img
          src={imageUrl}
          style={{ objectFit: "contain", width: "100%", height: "300px" }}
        />
      ) : (
        <video
          src={imageUrl}
          autoPlay
          muted
          style={{ width: "100%", height: "300px" }}
        />
      )}
    </>
  );
};

export default ImagePreview;
